import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function extractLocation(address: string | null | undefined): string | undefined {
  if (!address) return undefined;
  const match = address.match(/(\d{5})[,\s]+([^,\n]+?)(?:,|$)/);
  if (match) {
    return `${match[1]} ${match[2].trim()}`;
  }
  return undefined;
}
